export const CHECKOUT_URL = "https://alopecia-en.impultienda.ar/checkout/";

export const MOCKUP_IMAGE =
  "https://cdn.magicpatterns.com/uploads/qMbZ1uhJeXutYSCirSGixN/MOCKUP_ALOPECIA-EN.png";

export const AUTHOR_IMAGE =
  "https://cdn.magicpatterns.com/uploads/gUykacyr3B7EFYFfR6yeGX/Dr._Daniel_Mitchell_-_TRANSPLANT.png";
